'use client'

import React, { useEffect } from 'react'

const GAMAdBase = ({ config }) => {
  useEffect(() => {
    if (window.News12Ads) {
      window.News12Ads.addSlot(config)
    }
    return () => {
      if (window.News12Ads) {
        window.News12Ads.removeSlot(config.id)
      }
    }
  }, [config])

  return <div id={config.id} />
}

export default GAMAdBase
